module.exports = __webpack_public_path__ + "img/0decc3d34ec53d84d8db662274c13af5.png";